function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { defineComponent, // ref,
// watch,
computed } from "vue";
import EmptyView from "@pt/views/pt-entry/components/empty-view.vue";
import { t } from "@/lang";
export default defineComponent({
    components: {
        EmptyView: EmptyView
    },
    props: {
        list: {
            type: Array
        },
        actions: {
            type: Object
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var getTips = function(name) {
            if (name.indexOf("action") === -1) {
                return t("playTurbo.whole.plPoint.pointType.base");
            }
            return t("playTurbo.whole.plPoint.pointType.custom");
        };
        var basePointName = {
            gs: t("playTurbo.whole.plPoint.point.gs"),
            fc: t("playTurbo.whole.plPoint.point.fc"),
            ge: t("playTurbo.whole.plPoint.point.ge"),
            is: t("playTurbo.whole.plPoint.point.is")
        };
        var innerList = computed(function() {
            var ref;
            return ((ref = props.list) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                var pointName = item.name;
                // 如果point的值有&号，实际场景的key如右：action&action=1
                if (pointName.indexOf("&") !== -1) {
                    var aPoint = pointName.split("&");
                    if (aPoint[0] === "action") {
                        pointName = aPoint[1].replace("=", "");
                    }
                }
                return _objectSpreadProps(_objectSpread({}, item), {
                    name: pointName
                });
            })) || [];
        });
        var isCustomAction = function(name) {
            return name.indexOf("action") !== -1;
        };
        var getPointName = function(key) {
            if (basePointName[key]) {
                // 基础埋点名称
                return basePointName[key];
            } else if (props.actions && props.actions[key]) {
                // 自定义埋点名称
                return props.actions[key];
            } else if (key.indexOf("scene") !== -1) {
                var index = key.split("scene")[1];
                return t("playTurbo.whole.plPoint.point.scene", {
                    num: index
                });
            }
            return key;
        };
        var getCustomActionIndex = function(name) {
            var names = name.split("action");
            return names[names.length - 1];
        };
        return {
            innerList: innerList,
            getPointName: getPointName,
            getTips: getTips,
            t: t,
            isCustomAction: isCustomAction,
            getCustomActionIndex: getCustomActionIndex
        };
    }
});
